import { GET_BASELINES_SUCCESS } from './baseline.types';

const initialState = {
    baselineList: [],
};

export const baselinesReducer = (state = initialState, action) => {
    switch (action.type) {
        /** Baseline */

        case GET_BASELINES_SUCCESS:
            return {
                ...state,
                baselineList: action.payload,
            };

        /** End */

        default:
            return state;
    }
};
